const CounterItem = ({ items }) => {
	return (
		<div className="row">
			{items.map(item =>
				<div className="col-sm-6 col-md-4 col-lg-3 mb-4" key={item.title}>
					<div className="card border h-100 border-info">
						<div className="card-body">
							<div className="card-title ltr">{item.value}</div>
							<p className="card-text">{item.title}</p>
						</div>
					</div>
				</div>
			)}
		</div>
	);
};

export default CounterItem;